<template>
  <KwDropdown
    :show="show"
    width-auto
    @close="() => show = false"
    :align-right='right'
    v-if="currentLang !== 'lt'"
  >
    <div
      slot="toggle"
      @click="() => show = !show"
      :class="['flag-lng', currentFlagCss]">
    </div>
    <slot name="menu">
      <ul class="dropdown-menu">
        <li
          class="dropdown-menu__item"
          @click="() => switchLang('ru')"
          v-if="currentLang === 'ru'"
        >
          <span>Русский</span>
          <KwSvgicon name="check" class="ml_md" v-if="currentLang === 'ru'"/>
        </li>
        <li
          class="dropdown-menu__item"
          @click="() => switchLang('en')"
          v-if="currentLang === 'en'"
        >
          <span>English</span>
          <KwSvgicon name="check" class="ml_md" v-if="currentLang === 'en'"/>
        </li>
      </ul>
    </slot>
  </KwDropdown>
</template>

<script>
import KwSelect from '@kiwitaxi/vue-components/dist/KwSelect';
import KwSvgicon from '@kiwitaxi/vue-components/dist/KwSvgicon';
import KwDropdown from '@kiwitaxi/vue-components/dist/KwDropdown';
import { changeLocale } from '@/assets/js/utils/browser';
import { LANGUAGES } from '@/utils/Constants';

export default {
  name: 'Language',
  components: {
    KwSelect,
    KwSvgicon,
    KwDropdown,
  },
  props: {
    right: Boolean,
  },
  data() {
    return {
      show: false,
      languages: [...LANGUAGES],
    };
  },
  computed: {
    currentLang() {
      return this.$store.getters.lang;
    },
    currentFlagCss() {
      return `flag-lng-${this.currentLang}`;
    },
  },
  methods: {
    switchLang(value) {
      changeLocale(value);
    },
  },
};
</script>
<style lang="scss">
  .flag-lng {
    background: url("../../../assets/images/flags-new.png") no-repeat top left;
    width: 27px;
    height: 21px;
    border: 1px solid #c8ced4;
    &.flag-lng-ru {
      background-position: 0 -3720px;
    }
    &.flag-lng-en {
      background-position: 0 -1482px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header/components/Language.vue